import { createAsyncThunk } from "@reduxjs/toolkit";
import { sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import { logout } from "../auth/thunks";
import { LeaveTypeAPIService } from "src/constants";
import { IUpsertLeaveTypePayload } from "./types";

// Fetch all leave types
export const fetchLeaveTypeList = createAsyncThunk(
  "leaveType/fetchLeaveTypeList",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        LeaveTypeAPIService.GET_ALL_LEAVE_TYPES,
        "get"
      );

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }

      return response.result.data?.data || [];
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Something went wrong",
          })
        );
      }
      return [];
    }
  }
);

// Create / Update leave type (Upsert)
export const upsertLeaveType = createAsyncThunk(
  "leaveType/upsertLeaveType",
  async (payload: IUpsertLeaveTypePayload, { dispatch }) => {
    console.log("leave type data ", payload);

    try {
      const response = await sendRequestJSON(
        payload,
        LeaveTypeAPIService.UPSERT_LEAVE_TYPE,
        "post"
      );

      const result = response?.result?.data;

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response?.result?.message || "Unexpected error",
          })
        );
        return null;
      }

      dispatch(
        toastMessage({
          message: result?.message || "Leave Type saved successfully",
        })
      );

      // return data (newly created/updated item)
      return result?.data;
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Failed to save leave type",
          })
        );
      }
      return null;
    }
  }
);

// Soft Delete leave type (set inactive instead of removing)
export const deleteLeaveType = createAsyncThunk(
  "leaveType/deleteLeaveType",
  async (id: number, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        LeaveTypeAPIService.DELETE_LEAVE_TYPE(id),
        "delete"
      );

      const result = response?.result?.data;

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response?.result?.message || "Unable to delete leave type",
          })
        );
        return null;
      }

      dispatch(
        toastMessage({
          message: result?.message || "Leave Type deactivated successfully",
        })
      );

      return id; // return ID so slice can filter it out or mark inactive
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Delete failed",
          })
        );
      }
      return null;
    }
  }
);
